const LOGGER_DOMAINS_SEARCH_SUITE_ENTITY = 'domains-search-suite';
const EXPRESS_CHECKOUT_BM_APP_ID = '6bff5562-8a0f-4868-8a9e-c5afdbbd9e9e';
const EXPRESS_CHECKOUT_BM_SPLIT_PAGE_ID = '10442f06-be4f-450a-8a74-0b430edbfcb8';
export { LOGGER_DOMAINS_SEARCH_SUITE_ENTITY, EXPRESS_CHECKOUT_BM_APP_ID, EXPRESS_CHECKOUT_BM_SPLIT_PAGE_ID };
export let ExperimentSpecs = /*#__PURE__*/function (ExperimentSpecs) {
  ExperimentSpecs["PremiumSaleContentChange"] = "specs.premium.permenant50off";
  ExperimentSpecs["RenewalPricingStrategy"] = "specs.premium.domains.RenewalPricingStrategyInDomainResultsPage";
  ExperimentSpecs["AvailableTldsModal"] = "specs.premium.domains.AvailableTldsModal";
  ExperimentSpecs["MatchDomainCycleToPremiumCycle"] = "matchDomainCycleToPremiumCycle";
  ExperimentSpecs["LoggedInMobileGate"] = "specs.premium.domains.LoggedInMobileGate";
  ExperimentSpecs["LoggedInMobileConnect"] = "loggedInMobileConnectAndAssignDomains";
  ExperimentSpecs["DynamicSalePercentage"] = "domainsDynamicSalePercentage";
  return ExperimentSpecs;
}({});
//# sourceMappingURL=constants.js.map